<script>
import e4parent from "@/components/charts/e4parent";
export default {
  extends: e4parent,
  props: {},
  methods: {
    /* setOption() {
      this.isEmpty = true;
      this.$nextTick(() => {
        this.render(this.getMockData());
      });
    },  */
    getFormatExParams() {
      return {};
    },
    getMockData() {
      let res = {
        data: [
          {
            value: 100,
            name: "未入章",
          },
          {
            value: 200,
            name: "已入章1",
          },
          {
            value: 200,
            name: "已入章2",
          },
          {
            value: 200,
            name: "已入章3",
          },
          {
            value: 200,
            name: "已入章4",
          },
        ],
      };
      return res;
    },
    getLegendData: function (data) {
      let legendData = [];
      let len = data.length;
      for (let i = 0; i < len; i++) {
        let item = data[i];
        let name = item.name;
        legendData.unshift(name);
      }
      return legendData;
    },
    packageData: function (res) {
      // let title = this.title;
      let colorData = this.colorData;
      if (res.code && res.code == 200) {
        var avg_score = this.formData(res.data, "avg_score");
        var index_name = this.formData(res.data, "index_name");
        var index_score = this.formData(res.data, "index_score");
        var stock_code = this.formData(res.data, "stock_code");

        var seriesData = {
          avg_score: avg_score,
          index_name: index_name,
          index_score: index_score,
          stock_code: stock_code,
        };

        //
      } else {
        this.$message.closeAll();
        this.$message({
          message: "查找数据出错",
          type: "error",
          showClose: true,
        });
      }
      return {
        // title: title,
        // legendData: legendData,
        seriesData: seriesData,
        colorData: colorData,
      };
    },
    formData(v, m) {
      let arr = [];
      for (var i = 0; i <= v.length - 1; i++) {
        arr.unshift(v[i][m]);
      }
      return arr;
    },
    getEchartsOptions(res) {
      //  ;
      let data = this.packageData(res);
      //
      let option = {
        tooltip: {
          trigger: "axis",
        },
        /* legend: {
          left: "center",
          data: ["行业平均得分", "当前公司得分"],
        }, */
        legend: {
          orient: "vertical",
          bottom: 10,
          right: 30,
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          type: "scroll",
          height: 150,
          data: ["行业平均得分", "当前公司得分"],
          textStyle: {
            color: this.chartsLabelColor || "#333333",
          },
        },
        radar: [
          {
            indicator: (() => {
              var res = [];
              for (var i = 0; i <= data.seriesData.index_name.length - 1; i++) {
                res.push({
                  text: data.seriesData.index_name[i],
                  max: 100,
                  color: this.chartsLabelColor || "#333333",
                });
              }
              return res;
            })(),
            // indicator: [
            //   {
            //     text: '环境管理',
            //     max: 100,
            //   },
            //   {
            //     text: 1111,
            //     max: 100,
            //   },
            //   {
            //     text: 3,
            //     max: 100,
            //   },
            //   {
            //     text: 4,
            //     max: 100,
            //   },
            // ],

            // center: ["75%", "40%"],
            // radius: 80,
             splitArea: {
              areaStyle: {
                opacity: 0.5,
              }
            },
            splitLine: {
              lineStyle: {
                opacity: 0.5,
              }
            }
          },
        ],
        color: this.colorData,

        series: [
          {
            itemStyle: {
              // color: "#1890FF",
            },
            areaStyle: {
              opacity: 0.1,
            },
            symbolSize: 2,
            type: "radar",
            label: {
              show: false,
              formatter: "{c}",
              color: this.chartsLabelColor || "#333333",
              fontSize: 10,
            },
            lineStyle: {
              width: 1,
            },
            data: [
              {
                name: "当前公司得分",
                value: data.seriesData.index_score,
              },
              {
                name: "行业平均得分",
                value: data.seriesData.avg_score,
              },
            ],
          },
        ],
      };
      return option;
    },
  },
};
</script>
